import { Inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authService/authentication.service';
import { environment } from 'src/environments/environment';
import { API_BASE_URL } from '../services/appConfig/app-config.service';
import { GlobalConstants } from 'src/app/shared/services/constants/globalconstants';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private authService: AuthenticationService,
    @Inject(API_BASE_URL) public baseUrl?: string
  ) { }

  intercept(_req: HttpRequest<any>, _next: HttpHandler): Observable<HttpEvent<any>> {
    const isUserOfTypeCMS = !GlobalConstants.RespondRoutes.includes(this.router.url);

    const specialRoutes = ['summarization'];
    if (specialRoutes.some(route => _req.url.includes(route))) {
      return _next.handle(_req);
    }

    if (isUserOfTypeCMS) {
      const currentUser = this.authService.CurrentUserValue;

      if (currentUser && currentUser.AuthToken) {
        // set auth token for all request
        _req = _req.clone({
          url: `${this.baseUrl + environment.apiURL + _req.url}`,
          setHeaders: {
            Authorization: `Bearer ${currentUser.AuthToken}`
          }
        });
      }
      else {
        _req = _req.clone({
          url: `${this.baseUrl + environment.apiURL + _req.url}`,
        });
      }
    }
    else {
      const currentRespondUser = this.authService.RespondUserValue;

      if (currentRespondUser && currentRespondUser.AuthToken) {
        // set auth token for all request
        _req = _req.clone({
          url: `${this.baseUrl + environment.apiURL + _req.url}`,
          setHeaders: {
            Authorization: `Bearer ${currentRespondUser.AuthToken}`
          }
        });
      }
      else {
        _req = _req.clone({
          url: `${this.baseUrl + environment.apiURL + _req.url}`,
        });
      }
    }

    return _next.handle(_req);
  }
}
